<div class="single-courses-item mb-30">
    <div class="courses-image">
        <a (click)="routeToCourseDetail(course.id)" href="javascript:;" class="d-block"><img
                src="{{course.image.fileUrl}}" alt="image"></a>
    </div>
    <div class="courses-content">

        <h3><a class="d-inline-block" (click)="routeToCourseDetail(course.id)" href="javascript:;">{{course.name}}</a></h3>
        <!-- <p class="short-desc">{{course.descriptionEn}}</p> -->
    </div>

    <div class="courses-box-footer">
        <ul>
            <li class="students-number">
                <i class='bx bx-calendar'></i> {{course.updatedAt['seconds'] * 1000 | date:'MMM-dd-yyyy' }}
            </li>

            <li class="courses-price text-right">
                {{course.viewCount}} views
            </li>
        </ul>
    </div>
</div>
